import { createFileRoute } from "@tanstack/react-router";
import { ShortcutsPage } from "@/features/shortcuts/ShortcutsPage";
import { requireAuth } from "@/lib/guards";

export const Route = createFileRoute("/shortcuts")({
  beforeLoad: requireAuth,
  component: ShortcutsPage,
});
